export const userSortingColumns = [
    'role',
    'email',
    'firstName',
    'lastName',
];
